import { apiClient, handleApiError, isBackendEnabled } from '../client';
import {CreateUserRequest, User} from "../types";

/**
 * User API Service
 * Handles user-related API calls
 * Uses backend API if enabled, otherwise uses mock/local data
 */
export const userApi = {
    /**
     * Create a new user
     */
    createUser: async (data: CreateUserRequest): Promise<User> => {
        if (!isBackendEnabled() || !apiClient) {
            if (process.env.NODE_ENV === 'development') {
                console.warn('[User API] createUser: using mock (backend disabled). Set REACT_APP_USE_BACKEND=true and restart.');
            }
            // Mock implementation - just return the data as if it was created
            const now = new Date().toISOString();
            return {
                id: Math.floor(Math.random() * 1000000), // Mock ID for testing
                persona_id: data.persona_id,
                recommendation_user_id: data.recommendation_user_id || null,
                created_at: now,
                updated_at: null,
            };
        }

        try {
            // POST /user/ with body { persona_id }
            const response = await apiClient.post<User | { data: User }>(
                '/user',
                { persona_id: data.persona_id }
            );
            const raw = response.data;
            return 'id' in raw && typeof raw.id === 'number' ? (raw as User) : (raw as { data: User }).data;
        } catch (error) {
            throw handleApiError(error);
        }
    },
};
